export default __webpack_public_path__ + "static/media/p-31.97736695.svg";